import * as React from 'react';
import { Wrapper } from '../SharedChatBubble.styled';
import { StyledChatBubble } from './ChatBubble.styled';
import { ChatBubbleStatus } from '../SharedChatBubbleStatus';
export const ChatBubble = ({ author, state, text, time = '', errorMessage = 'Message failed to send' }) => {
    return (React.createElement(Wrapper, { author: author },
        React.createElement(StyledChatBubble, { author: author, state: state }, text),
        React.createElement(ChatBubbleStatus, { author: author, state: state, time: time, errorMessage: errorMessage })));
};
//# sourceMappingURL=ChatBubble.js.map